import './init'
import SettingsService from 'live/services/settings'
import eventbasedClockSettings from './eventbasedClockSettings'

SettingsService.register(eventbasedClockSettings)